<template>
  <div
    class="fcc-investment"
    data-aos="zoom-in-up"
    data-aos-duration="250"
    data-aos-easing="ease-out-cubic"
  >
    <div class="holder" :class="showDeposit || deposit === 'true' ? '' : 'no-deposits'">
      <FCTitle :h2="this.h2" :h3="this.h3" />
      <div class="copy-holder">
        <slot name="copy"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import FCTitle from "@/components/patterns/FCTitle";
export default {
  components: {
    FCTitle,
  },
  props: {
    h2: String,
    h3: String,
    deposit: String,
  },
  computed: {
    showDeposit: function () {
      //const today = moment();
      //const goLive = moment.tz("2020-05-12 08:00", "America/New_York");
      //if (today > goLive) {
      //  return true;
      //}
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-holder {
  font-size: 1em;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 1.2em;
  overflow: auto;
  max-height: calc(100vh - 160px - 160px);
  padding-right: 25px;
}
.no-deposits {
  a {
    opacity: 0.4;
    pointer-events: none;
  }
}
.fcc-investment {
  background-image: linear-gradient(
    270deg,
    rgba(5, 17, 42, 0.84) 52%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 100px;
  width: 50%;
  height: 100%;
}
.holder {
  position: absolute;
  top: 160px;
  right: 0;
  margin-right: 50px;
  width: 550px;
}
.seats-multiplier {
  display: inline-block;
  vertical-align: top;
  margin-left: 75px;
  button {
    font-size: 36px;
    color: #ffffff;
    text-align: center;
  }
  .value {
    display: inline-block;
    margin: 0 25px;
    margin-top: 10px;
    font-size: 36px;
    letter-spacing: 0;
    font-weight: bold;
    padding: 15px;
    width: 75px;
    height: 60px;
    box-sizing: border-box;
    background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.48) 0%,
      rgba(54, 54, 54, 0.48) 51%,
      rgba(152, 152, 152, 0.48) 50%,
      rgba(0, 0, 0, 0.48) 100%
    );
    border: 1px solid #ffffff;
  }
}
.map {
  flex-grow: 1;
  padding-left: 10px;
  max-width: 225px;
  img {
    width: 100%;
  }
}
.investment-element {
  background: #fff;
  color: $accent-color;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  .pad {
    line-height: 1.4;
    padding-top: 10px;
  }
}
.price-per-year {
  font-weight: bold;
  color: $accent-color;
  font-size: 56px;
  box-sizing: border-box;
}
.margin-bottom {
  margin-bottom: 15px;
}
.margin-top {
  margin-top: 15px;
}
.orange {
  color: #ff5100;
}
p {
  &.small {
    font-size: 0.8em;
  }
}
.text-center {
  text-align: center;
}
.inline-block {
  display: inline-block;
}
.fc-button {
  margin-bottom: 10px;
  display: block;
  width: 100%;
}
@media (max-width: 1000px) {
  .fcc-investment {
    background-image: linear-gradient(90deg, #07173a 0%, #030a18 100%);
    height: auto;

    position: static;
    min-height: 100vh;
    overflow: auto;
    padding: 25px;
    box-sizing: border-box;
    width: 100%;
    .holder {
      position: static;
      width: 100%;
    }
    .copy-holder {
      text-align: center;
    }
  }
}
@media (max-width: 610px) {
  .fcc-investment {
    padding: 25px;
  }
  .holder {
    margin: 0;
  }
  .copy-holder {
    max-height: unset;
    padding: 0;
  }
  .investment-element {
    display: block;
    text-align: center;
    .map {
      display: block;
      margin: 0;
      max-width: unset;
    }
  }
}
</style>